import { REQUEST, FAILURE, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

export const GET_WAZZUP_IFRAME = createRequestTypes('GET_WAZZUP_IFRAME');
export const getWazzupIframe = {
  request: () => action(GET_WAZZUP_IFRAME[REQUEST]),
  success: data => action(GET_WAZZUP_IFRAME[SUCCESS], { data }),
  failure: error => action(GET_WAZZUP_IFRAME[FAILURE], { error }),
};

export const GET_WAZZUP_CONTACT_IFRAME = createRequestTypes('GET_WAZZUP_CONTACT_IFRAME');
export const getWazzupContactIframe = {
  request: contactId => action(GET_WAZZUP_CONTACT_IFRAME[REQUEST], { contactId }),
  success: (contactId, status, link) => action(GET_WAZZUP_CONTACT_IFRAME[SUCCESS], { contactId, status, link }),
  failure: (contactId, status) => action(GET_WAZZUP_CONTACT_IFRAME[FAILURE], { contactId, status }),
};
export const CLEAR_WAZZUP_CONTACT_IFRAME = 'CLEAR_WAZZUP_CONTACT_IFRAME';
export const clearWazzupContactIframe = contactId => action(CLEAR_WAZZUP_CONTACT_IFRAME, { contactId });

export const GET_WAZZUP_AUTHORIZE_URL = createRequestTypes('GET_WAZZUP_AUTHORIZE_URL');
export const getWazzupAuthorizeUrl = {
  request: () => action(GET_WAZZUP_AUTHORIZE_URL[REQUEST]),
  success: data => action(GET_WAZZUP_AUTHORIZE_URL[SUCCESS], { data }),
  failure: error => action(GET_WAZZUP_AUTHORIZE_URL[FAILURE], { error }),
};

export const SET_WAZZUP_NEED_AUTH = 'SET_WAZZUP_NEED_AUTH';
export const setWazzupNeedAuth = value => ({
  type: SET_WAZZUP_NEED_AUTH,
  value,
});

export const GET_WAZZUP_CHANNELS = createRequestTypes('GET_WAZZUP_CHANNELS');
export const getWazzupChannels = {
  request: () => action(GET_WAZZUP_CHANNELS[REQUEST]),
  success: data => action(GET_WAZZUP_CHANNELS[SUCCESS], { data }),
  failure: error => action(GET_WAZZUP_CHANNELS[FAILURE], { error }),
};

export const SEND_WAZZUP_MESSAGE = createRequestTypes('SEND_WAZZUP_MESSAGE');

export const sendMessageByWazzup = {
  request: data => action(SEND_WAZZUP_MESSAGE[REQUEST], data),
  success: data => action(SEND_WAZZUP_MESSAGE[SUCCESS], { data }),
  failure: error => action(SEND_WAZZUP_MESSAGE[FAILURE], { error }),
};
